import React from 'react';
// import { Link } from "react-router-dom";
import { NavbarItems, SocialItems } from './../Data'
import './../style/Global.css';
import './../style/Navbar.css';

 const Navbar = () => {
  return (
    <div className='navbar d-flex jc-sb'>
      <ul className='d-flex jc-end as-s nav-link-wrapp'>
        {NavbarItems.map((item,index) => {
          return (
            <li className='nav-item' key={index}>
              <a href={item.linkUrl} className='nav-link'> {item.linkName}</a>
            </li>
          )
        })
      }
      </ul>

      <ul className='mt--20'>
        {SocialItems.map((item, index) => {
            return (
              <li key={index}>
                <a href={item.linkUrl} className='nav-social-link'>
                  <img className='nav-icon' src={item.icon} alt="" />
                </a>
              </li>
            )
          })
        }
      </ul>
    </div>
  )
}

export default Navbar
